import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import ClickOutside from 'react-onclickoutside';

import isFunction from 'lodash/isFunction';

import PayoutsItem from './payouts-item';
import PointBalance from './point-balance';

const propTypes = {
	opened: PropTypes.bool,
	toggle: PropTypes.func,
	close: PropTypes.func,
	intl: PropTypes.func,
	value: PropTypes.object.isRequired
};
const defaultProps = {
	opened: false,
	intl: t => t
};

// TODO: get translations function from context
class DebtWidget extends React.Component {
	constructor(props) {
		super(props);
	}

	handleClickOutside() {
		const { close } = this.props;
		if (this.props.opened && isFunction(close)) {
			close();
		}
	}

	render() {
		const {
			opened,
			toggle,
			availableCurrencies,
			intl,
			value
		}	= this.props;

		return <div
			onClick={toggle}
			className={cn('payouts', opened && 'payouts--opened')}
		>
			<div className="payouts-item-wrap">
				{
					availableCurrencies
						.map((curr, index) => <PayoutsItem key={index} intl={intl} value={value} currency={curr.id} />)
				}
				{process.env.CPA_ENV === 'rocket' && (
					<PointBalance value={+value.points.debt.amount} />
				)}
			</div>
		</div>;
	}
}

DebtWidget.propTypes = propTypes;
DebtWidget.defaultProps = defaultProps;

export default ClickOutside(DebtWidget);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/debt-widget/main.js